import { Modal } from '@mui/material';
import { styled } from '@mui/material/styles';
import { KModalSize } from './types.js';

var maxWidthThemed = function (size) {
    switch (size) {
        case KModalSize.XSmall:
            return 40;
        case KModalSize.Small:
            return 50;
        case KModalSize.Regular:
            return 80;
        case KModalSize.Large:
            return 120;
        default:
            return 120;
    }
};
var PREFIX = "KModal";
var classes = {
    body: "".concat(PREFIX, "-body"),
    backdrop: "".concat(PREFIX, "-backdrop"),
    scrollBox: "".concat(PREFIX, "-scrollBox"),
    content: "".concat(PREFIX, "-content")
};
var StyledKModal = styled(Modal, {
    shouldForwardProp: function (prop) { return prop !== "size"; }
})(function (_a) {
    var _b, _c;
    var theme = _a.theme, _d = _a.size, size = _d === void 0 ? KModalSize.Large : _d;
    return (_b = {
            overflow: "auto"
        },
        _b["& .".concat(classes.body)] = {
            padding: theme.spacing(0, 2, 2)
        },
        _b["& .".concat(classes.scrollBox)] = {
            width: "100%",
            minHeight: "100%",
            padding: "4vh 0"
        },
        _b["& .".concat(classes.content)] = (_c = {
                margin: "auto",
                maxWidth: theme.spacing(maxWidthThemed(size)),
                backgroundColor: theme.palette.background.paper,
                boxShadow: theme.shadows[5],
                borderRadius: theme.shape.borderRadius,
                overflow: "hidden"
            },
            _c[theme.breakpoints.up("xs")] = {
                width: "95vw"
            },
            _c[theme.breakpoints.up("sm")] = {
                width: "85vw"
            },
            _c[theme.breakpoints.up("md")] = {
                width: "75vw"
            },
            _c[theme.breakpoints.up("lg")] = {
                width: "65vw"
            },
            _c),
        _b);
});

export { classes, StyledKModal as default };
//# sourceMappingURL=index.styled.js.map
